import { upgradeCustomerPlan } from './common/services/customer';

export default {
    upgradeCustomerPlan(upgradePlanTo, trialDays) {
        return upgradeCustomerPlan({ upgradePlanTo, trialDays });
    },
};
